import type { TFunction } from "react-i18next";

export type ImportJobErrorFields = {
    errorCode?: string;
    errorMessage?: string;
    errorParams?: Record<string, string | number>;
};

export function translateImportJobError(
    t: TFunction<"translation", undefined>,
    { errorCode, errorMessage, errorParams }: ImportJobErrorFields,
): string | null {
    if (errorCode) {
        const key = `ImportData.Errors.${errorCode}`;
        const translated = t(key, { ...errorParams, message: errorMessage ?? "" });

        if (translated !== key) {
            return translated;
        }
    }

    return errorMessage || null;
}
